import { SignInButton, SignUpButton } from "@clerk/clerk-react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Car } from "lucide-react";

export default function UnauthenticatedApp() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted/50 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="flex aspect-square size-12 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Car className="size-6" />
            </div>
          </div>
          <CardTitle className="text-2xl">{t("appName")}</CardTitle>
          <p className="text-muted-foreground">{t("appDescription")}</p>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-sm text-muted-foreground">
            Sign in to manage your GPSBox device
          </p>
          <div className="space-y-2">
            <SignInButton mode="modal">
              <Button className="w-full" size="lg">
                {t("signIn")}
              </Button>
            </SignInButton>
            <SignUpButton mode="modal">
              <Button variant="outline" className="w-full" size="lg">
                {t("signUp")}
              </Button>
            </SignUpButton>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
